import ProfileInfo from './ProfileInfo';

export default ProfileInfo;
